import { render, staticRenderFns } from "./Ekspedisi.vue?vue&type=template&id=2a9aabb6&"
import script from "./Ekspedisi?vue&type=script&lang=js&"
export * from "./Ekspedisi?vue&type=script&lang=js&"
import style0 from "./Ekspedisi.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports